import classNames from 'classnames'
import { useState } from 'react'
import { sendGTMEvent } from '../../../../../helpers/gtmHelper'
import { CurrentUser } from '../../../../../model/Common/common.interface'
import { useCurrentUser } from '../../../../../modules/context/UserContext'
import useAppRouter from '../../../../../modules/hooks/common/useAppRouter'
import { LOCALE_KO } from '../../../../../modules/i18n/config'
import { s_home } from '../../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { STUDENT_BTN_ID } from '../../../../../modules/ids/gtm/student'
import { VIDEO_INTRO } from '../../../../../modules/images'
import urls from '../../../../../modules/urls'
import { CDN_URL } from '../../../../../modules/vars'
import { IMG_HOME_CHEVRON_DOWN_GRAY_LARGE } from '../../../constants/home.constants'
import { sendHomeSectionClickEvent } from '../../../helpers/HomeHelpers'
import ProfileEnterModal from '../../../profile/ProfileEnterModal'

type IntroSectionProps = {
  bgColor: string
}

const IntroSection: React.FC<IntroSectionProps> = ({ bgColor }) => {
  const { currentUser } = useCurrentUser()
  const { t, locale } = useTranslation()

  const router = useAppRouter()
  const [isShowProfileEnter, setIsShowProfileEnter] = useState(false)
  const handleClickStartRingleBtn = (_currentUser: CurrentUser, _btnName: string) => {
    sendHomeSectionClickEvent(
      STUDENT_BTN_ID.ClICK_START_RINGLE,
      `Intro Section CTA 버튼 - ${_btnName}`,
      currentUser,
      router,
      undefined,
      null,
      'pc_web'
    )

    sendGTMEvent(STUDENT_BTN_ID.CLICK_TRIAL_LESSON, {
      btn_name: '4,000원으로 첫 수업 체험하기',
      btn_area: 'landing_hero',
      device_type: 'pc_web',
    })

    /**
     * 로그인 전에는 회원가입 페이지로 이동
     * 로그인 이후에는 포털 홈으로 페이지로 이동
     */
    _currentUser ? router.push(urls.student.newPortal.home) : setIsShowProfileEnter(true)
  }

  const handleClickBottomChevron = () => {
    window.scrollTo({
      top: 940,
      behavior: 'smooth',
    })
  }

  return (
    <div
      className="relative flex min-h-[708px] flex-col items-center justify-start"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex w-full max-w-[1080px] items-start justify-between px-[20px] pt-[122px] pb-[252px]">
        {/* LEFT SECTION */}
        <div className="max-w-[442px]">
          <h1
            className={classNames(
              'whitespace-pre-line text-left text-purple-500',
              locale === LOCALE_KO ? 'Hero2-48Bd' : 'Hero3-36Bd'
            )}
          >
            {t(s_home.hero.title.desktop)}
          </h1>
          <p className={classNames('mt-12 text-[#585D71]', locale === LOCALE_KO ? 'Title1-20Md' : 'Title2-18Md')}>
            {t(s_home.hero.subtitle.desktop)}
          </p>
          <button
            className={classNames(
              'mt-[35px] min-w-[222px] rounded-[7px] bg-[#4130A4] py-16 text-white',
              locale === LOCALE_KO ? 'Body1-16Bd' : 'Body2-14Bd'
            )}
            onClick={() => handleClickStartRingleBtn(currentUser, t(s_home.hero.cta.desktop_20))}
          >
            {t(s_home.hero.cta.desktop_20)}
          </button>
        </div>

        {/* RIGHT - VIDEO SECTION */}
        <div className="max-w-[513px]">
          <video
            autoPlay
            loop
            muted={true}
            playsInline
            poster={VIDEO_INTRO}
            preload="auto"
            className="rounded-[12px] drop-shadow-[0px_2px_15px_rgba(0,0,0,0.2)]"
          >
            <source src={`${CDN_URL}/new-theme/landing/home/videos/230410_plus-landing_intro.mp4`} type="video/mp4" />
            <source src={`${CDN_URL}/new-theme/landing/home/videos/230410_plus-landing_intro.webm`} type="video/webm" />
          </video>
        </div>
      </div>

      {isShowProfileEnter && <ProfileEnterModal isOpen={isShowProfileEnter} setIsOpen={setIsShowProfileEnter} />}
      {/* ICON SECTION */}
      <button className="absolute bottom-[78px]" onClick={() => handleClickBottomChevron()}>
        <img src={IMG_HOME_CHEVRON_DOWN_GRAY_LARGE} alt="chevron-gray-bottom" className="animate-bounce" />
      </button>
    </div>
  )
}

export default IntroSection
